import { render } from "./BaseBackButton.vue?vue&type=template&id=b9749722&scoped=true"
import script from "./BaseBackButton.vue?vue&type=script&lang=js"
export * from "./BaseBackButton.vue?vue&type=script&lang=js"

import "./BaseBackButton.vue?vue&type=style&index=0&id=b9749722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9749722"]])

export default __exports__